import WechatShareGuide from '@/sc_components/WechatShareGuide'
import logger from '@/sc_utils/logger'
import { isInApp, isInWechat, isInQQOrQZ, isInMiniProgram, deviceType } from './env-helper'

/**
 * 设置分享信息
 * @param {分享的标题} title
 * @param {分享的简介} desc
 * @param {设置分享图标} icon
 * @param {分享的页面} link
 * @param {分享渠道， 1：微信、2：朋友圈、3：QQ、4：QQ空间} shareTypes
 * @param {分享回调} callback
 */
let shareInfo = {}

let guideTips = {}

// 是否在好车主App
const isInHczApp = () => {
	const ua = navigator.userAgent
	return /(hczandroid|hczIos)/gi.test(ua)
}

const setShareInformation = (params) => {
	shareInfo = {
		title: params.title || 'i深圳',
		desc: params.desc || '您的政务生活服务管家',
		icon: params.icon || 'https://isz-web.sz.gov.cn/sz/assets/images/logo-120.jpg',
		link: params.link || window.location.href,
		shareTypes: getShareTypes(params.shareTypes || [1, 2, 3, 4]),
		callback: params.callback || null
	}

	guideTips = params.guideTips || {}

	// 市民通app
	if (isInApp()) {
	  const { rightBtns } = params
		if (rightBtns === false) return true// 是否需要设置右上角分享按钮
		window.sc.setToolBar({
			rightBtns: typeof rightBtns === 'object' && rightBtns.length > 0 ? rightBtns : [{
				iconType: 0,
				action: 'rightBtnAction0',
				callback: () => {
					shareAction()
				}
			}]
		})
		return true
	}

	// 小程序环境
	if (isInMiniProgram()) return true

	// 微信环境
	if (isInWechat()) {
		window.wxBridge.setShareTitle(shareInfo.title)
		window.wxBridge.setShareDesc(shareInfo.desc)
		window.wxBridge.setShareLink(shareInfo.link)
		window.wxBridge.setShareIcon(shareInfo.icon)
		// 微媒体，需要重写分享配置
		if (window.location.href.indexOf('weimeiti') >= 0) {
			let shareData64 = {
				title: shareInfo.title,
				desc: shareInfo.desc,
				imgUrl: shareInfo.icon,
				link: shareInfo.link,
				success () {
				},
				cancel () {
				}
			}
			shareData64 = window.tar.shapeShareAppMessage(shareData64)

			window.wxBridge.setShareTitle(shareData64.title)
			window.wxBridge.setShareDesc(shareData64.desc)
			window.wxBridge.setShareLink(shareData64.link)
			window.wxBridge.setShareIcon(shareData64.imgUrl)
			// eslint-disable-next-line no-unused-expressions
			window.wxBridge.setShareActionCallback(shareData64.success)
		} else {
			// eslint-disable-next-line no-unused-expressions
			shareInfo.callback && window.wxBridge.setShareActionCallback(shareInfo.callback)
		}
		return true
	}
	// QQ环境
	if (isInQQOrQZ()) {
		const shareParams = {
			title: shareInfo.title,
			summary: shareInfo.desc,
			pic: shareInfo.icon,
			url: shareInfo.link
		}
		window.setShareInfo(shareParams)
		return true
	}
	// 平安好车主app
	if (isInHczApp()) {
		const shareParams = {
			MethodName: 'shareStatus',
			CallBack: shareInfo.callback,
			Parameters: {
				status: 1,
				title: shareInfo.title,
				desc: shareInfo.desc,
				url: shareInfo.link,
				thumbImg: shareInfo.icon
			}
		}
		if (window.hczApp && window.hczApp.CallNative) {
			window.hczApp.CallNative(JSON.stringify(shareParams))
		}
		return true
	}
	// 第三方浏览器，不支持设置页面分享信息
	return false
}

// 获取市民通app内分享渠道
const getShareTypes = (shareTypesArr) => {
	const shareChanelMap = shareTypesArr.map((index) => {
		return { platformID: index }
	})
	return shareChanelMap
}

// 分享
const shareAction = () => {
	if (isInApp()) {
		// 解决i深圳内ios触发分享键盘收起页面底部空白的问题
		if (deviceType() === '1') {
			const inputDoms = document.getElementsByTagName('input')
			for (let i = 0; i < inputDoms.length; i++) {
				inputDoms[i].blur()
			}
		}
		window.sc.share({
			...shareInfo,
			image: shareInfo.icon,
			content: shareInfo.desc,
			shareUrl: shareInfo.link
		}, (result) => {
			// 1.5.0双终端都忘记分享成功后回调了，这里的SUCCESS回调在1.5.0版本调不回来
			if (result.code === window.sc.CODE.SUCCESS) {
				// alert("分享成功：" + result.message);
				shareInfo.callback && shareInfo.callback()
			}
			// 当前版本过低，不支持该Hybrid交互接口
			else if (result.code === window.sc.CODE.NOT_SUPPORT) {
				// TODO: 版本太低，需要弹提示不支持分享
				logger.debug(`[EnvHelper] TODO: 版本太低，需要弹提示不支持分享`)
				alert(`版本太低，不支持分享`)
			}
		})
	} else if (isInMiniProgram()) {
	// 小程序内点击分享，弹分享引导浮层
		WechatShareGuide.show({
			mp: guideTips.mp
		})
	} else if (isInWechat() || isInQQOrQZ()) {
		// 微信内点击分享，弹分享引导浮层
		WechatShareGuide.show({
			wx: guideTips.wx
		})
	} else {
		// TODO: 非App环境，点击分享，提示下载App
		logger.debug(`[EnvHelper] TODO: 非App环境，点击分享，提示下载App`)
		alert(`非i深圳、微信或QQ环境，暂不支持分享，请使用微信、QQ或下载i深圳体验`)
	}
}

export {
	setShareInformation,
	shareAction,
	isInHczApp
}
